import {Injectable} from '@angular/core';

export type BreadcrumbHtmlElement = HTMLElement & {
  updateBreadcrumb: () => any;
};

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private _component: BreadcrumbHtmlElement | null = null;

  set component(component: BreadcrumbHtmlElement) {
    this._component = component;
  }

  updateBreadcrumb() {
    if (this._component) {
      this._component.updateBreadcrumb();
    }
  }
}
